import { useGetNextVersionInfo } from "../api/mappingVersion";

export function useNextVersionInfo(drawingToolId: string | undefined) {
  const { data, isLoading, isError } = useGetNextVersionInfo(drawingToolId);

  return {
    nextVersionNumber: data?.nextVersionNumber ?? 0,
    // Left empty (not a guessed "Version N") while the request is in flight, so callers that
    // seed a form field from this only do so once the real suggestion has arrived.
    suggestedVersionName: data?.suggestedVersionName ?? "",
    existingVersionNames: data?.existingVersionNames ?? [],
    // 0 while in flight, so callers gating a destructive action on "is this the only version?"
    // stay on the conservative side until the real count arrives.
    versionCount: data?.versionCount ?? 0,
    isLoading,
    isError
  };
}
